import {Flex} from '@chakra-ui/react';
import {useQuery} from '@tanstack/react-query';
import {getPromoCategory, getPromoCategoryMarkets} from 'api/requests';
import {PromoSkeleton, PromotionList, Section} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {IPromoCategoryResponse, ProviderTypeEnum, QueryKeyEnum} from 'types';

const skeletonArray = new Array(20).fill(1);

interface IProps {
  locale: string;
  coordinates: string;
  providerType: ProviderTypeEnum;
}

export const PromotionsSection: FC<IProps> = ({locale, coordinates, providerType}) => {
  const isMarkets = providerType === ProviderTypeEnum.MARKET;

  const {data: promotions, isLoading: isLoadingPromotions} = useQuery<IPromoCategoryResponse[]>({
    queryKey: [isMarkets ? QueryKeyEnum.PROMO_CATEGORY_MARKET : QueryKeyEnum.PROMO_CATEGORY, locale, coordinates],
    queryFn: () => (isMarkets ? getPromoCategoryMarkets() : getPromoCategory()),
    staleTime: 0,
  });
  const {t} = useTranslation();

  if (!promotions && !isLoadingPromotions) return null;

  const promoProviders = promotions ? promotions.filter((item) => item.providers_count) : [];
  return (
    <>
      {isLoadingPromotions ? (
        <Section title={t('PROMOTION_TITLE')} py={0}>
          <Flex overflow="hidden">
            {skeletonArray.map((_, index) => (
              <PromoSkeleton key={index} />
            ))}
          </Flex>
        </Section>
      ) : (
        <>
          {promoProviders.length > 0 && (
            <Section title={t('PROMOTION_TITLE')} py={0}>
              <PromotionList promotions={promotions} isMarkets={isMarkets} />
            </Section>
          )}
        </>
      )}
    </>
  );
};
